import { render } from "./vipWelfare.vue?vue&type=template&id=8ca4a4c4&scoped=true&ts=true"
import script from "./vipWelfare.vue?vue&type=script&lang=ts"
export * from "./vipWelfare.vue?vue&type=script&lang=ts"

import "./vipWelfare.vue?vue&type=style&index=0&id=8ca4a4c4&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca4a4c4"]])

export default __exports__